<script>import * as d3 from "d3";
import Slice from "./Slice.svelte";
import SliceLabels from "./SliceLabels.svelte";
import { okhsl } from "../../../../d3-mapp/color/index.js";
export let tag = "";
export let aspectRatio;
export let size;
export let padding = 5;
export let defaultFill = okhsl("transparent");
export let data;
export let label;
export let value = (d) => d.value;
export let onLabel = (datum) => datum.value.toString();
export let centerLabel = (data2) => Object.values(data2.distribution).reduce((sum, d) => sum + d.value, 0).toString();
export let innerRadius = 0.4;
export let outerRadius = 0.8;
export let tickRadius = 0.9;
export let centerTextSize = 0.8;
export let duration = 400;
export let showLabel = true;
export let showOnLabel = true;
let radius;
let sliceArc;
let outerArc;
let tickArc;
let arcData = [];
const pieGenerator = d3.pie().sort(null).value(value);
$: {
  radius = Math.min(size * aspectRatio, size) / 2 - padding;
  sliceArc = d3.arc().innerRadius(radius * innerRadius).outerRadius(radius * outerRadius);
  outerArc = d3.arc().innerRadius(radius * outerRadius).outerRadius(radius * outerRadius);
  tickArc = d3.arc().innerRadius(radius * tickRadius).outerRadius(radius * tickRadius);
}
$: {
  arcData = data ? pieGenerator(Object.values(data.distribution)) : [];
}
</script>

<g
	class="pie-chart-out {tag}"
	transform={`translate(${(size * aspectRatio) / 2},${size / 2})`}
	stroke="none"
	fill={defaultFill.formatHex()}
	fill-opacity={defaultFill.opacity}
>
	<g class="slices">
		{#each arcData as arcDatum (arcDatum.data.key)}
			<Slice title={label} {duration} {arcDatum} {sliceArc} />
		{/each}
	</g>
	<g class="labels">
		{#each arcData as arcDatum (arcDatum.data.key)}
			<SliceLabels
				{label}
				{onLabel}
				{duration}
				{arcDatum}
				{radius}
				{showLabel}
				{showOnLabel}
				{sliceArc}
				{outerArc}
				{tickArc}
			/>
		{/each}
	</g>
	{#if centerLabel}
		<g class="total"
			><text
				text-anchor="middle"
				dy="0.35em"
				style={`font-size: ${radius * innerRadius * centerTextSize}px`}>{centerLabel(data)}</text
			></g
		>
	{/if}
</g>

<style>
	g.labels :global(text) {
		fill: currentColor;
		fill-opacity: 1;
		font: bold 10px Roboto, sans-serif;
	}
	g.labels :global(text.count) {
		fill: white;
	}
	g.labels :global(polyline) {
		stroke: currentColor;
		stroke-opacity: 1;
		stroke-width: 1;
	}
	g.total text {
		fill: currentColor;
		fill-opacity: 1;
		font: bold 10px Roboto, sans-serif;
	}
</style>
